import { frontendURL } from '../../../helper/URLHelper';

const CampaignsListView = () => import('./CampaignsListView.vue');
const CampaignCreateView = () => import('./CampaignCreateView.vue');
const CampaignDetailView = () => import('./CampaignDetailView.vue');
const TemplatesListView = () => import('./TemplatesListView.vue');
const TemplateCreateView = () => import('./TemplateCreateView.vue');

export default {
  routes: [
    { path: frontendURL('accounts/:accountId/envio-masivo'), name: 'wa_campaigns_list', component: CampaignsListView, meta: { permissions: ['administrator','module_envio_masivo'] } },
    { path: frontendURL('accounts/:accountId/envio-masivo/nuevo'), name: 'wa_campaigns_create', component: CampaignCreateView, meta: { permissions: ['administrator','module_envio_masivo'] } },
    { path: frontendURL('accounts/:accountId/envio-masivo/templates'), name: 'wa_templates_list', component: TemplatesListView, meta: { permissions: ['administrator','module_envio_masivo'] } },
    { path: frontendURL('accounts/:accountId/envio-masivo/templates/nuevo'), name: 'wa_templates_create', component: TemplateCreateView, meta: { permissions: ['administrator','module_envio_masivo'] } },
    { path: frontendURL('accounts/:accountId/envio-masivo/:id'), name: 'wa_campaigns_detail', component: CampaignDetailView, meta: { permissions: ['administrator','module_envio_masivo'] } },
  ],
};
